import { Box } from '@mui/material';
import { LPDataTypeParams } from 'api/reports-service/reports-service.types';
import IncLineChart from 'components/charts/inc-line-chart/inc-line-chart.component';
import SingleItemTooltip from 'components/charts/inc-line-chart/tooltip/single-item-tooltip.component';
import {
  useSearchParamsContext,
  useSearchQueryContext,
} from 'components/search/search.hooks';
import { DateTime } from 'luxon';
import { dateXAxis } from 'pages/loyalty-performance-report/loyalty-performance-report.utils';

type TrendsLineChartProps = {
  queryName: string;
  dataType?: keyof LPDataTypeParams;
  'data-testid': string;
};

const TrendsLineChart = ({
  queryName,
  dataType = 'datatype',
  ...rest
}: TrendsLineChartProps) => {
  const {
    data,
    queryState: { isFetching },
  } = useSearchQueryContext(queryName);
  const { series, xlabels } = data?.lineChart ?? {};

  const lineChartSeries = series?.map(item => {
    return { ...item, showMark: item.data.length === 1 };
  });

  const { searchParams } = useSearchParamsContext();
  const dataTypeParam = searchParams[dataType];

  return (
    <Box display="grid" gridAutoRows={{ xs: 450 }} gap={2}>
      <IncLineChart
        series={lineChartSeries}
        xlabels={xlabels?.map((label: string) =>
          DateTime.fromISO(label).toFormat('MMM dd'),
        )}
        LineChartProps={{
          loading: isFetching,
          xAxis: [dateXAxis(data?.lineChart?.xlabels)],
          slots: {
            tooltip: SingleItemTooltip,
          },
        }}
        title={
          dataTypeParam.options.find(({ id }) => dataTypeParam.value === id)
            ?.label
        }
        {...rest}
      />
    </Box>
  );
};

export default TrendsLineChart;
